import React, { useState } from "react";
import { range, sampleSize } from "lodash";

import Button from "../Button";
import ScoreOverlay from "../ScoreOverlay";

import {
  Wrapper,
  Title,
  TopicWrapper,
  TopicLabel,
  TopicsWrapper,
  ArrowLeft,
  ArrowRight,
  TopicBlock,
  Subtitle,
  DotsWrapper,
  Dot
} from "./styled";

import topics from "../topics";

function Topic({ onSetTopicIds, onNext }) {
  const [firstBlock] = useState(sampleSize(topics.first, 3));
  const [secondBlock] = useState(sampleSize(topics.second, 3));
  const [thirdBlock] = useState(sampleSize(topics.third, 3));
  const [firstIndex, setFirstIndex] = useState(0);
  const [secondIndex, setSecondIndex] = useState(0);
  const [thirdIndex, setThirdIndex] = useState(0);
  const [scoreOverlay, setScoreOverlay] = useState(false);

  const handleNext = () => {
    const topicIds = range(3).reduce((acc, cur, i) => {
      switch (i) {
        case 0:
          return [...acc, firstBlock[firstIndex].id];
        case 1:
          return [...acc, secondBlock[secondIndex].id];
        case 2:
          return [...acc, thirdBlock[thirdIndex].id];
        default:
          break;
      }

      return acc;
    }, []);
    setScoreOverlay(true);
    onSetTopicIds(topicIds);

    setTimeout(() => {
      setScoreOverlay(false);
      onNext(1);
    }, 1000);
  };

  const handlePrevTopic = key => {
    if (key === 1) {
      if (firstIndex > 0) {
        setFirstIndex(prev => prev - 1);
      } else {
        setFirstIndex(firstBlock.length - 1);
      }
    }

    if (key === 2) {
      if (secondIndex < secondBlock.length - 1) {
        setSecondIndex(prev => prev + 1);
      } else {
        setSecondIndex(0);
      }
    }

    if (key === 3) {
      if (thirdIndex < thirdBlock.length - 1) {
        setThirdIndex(prev => prev + 1);
      } else {
        setThirdIndex(0);
      }
    }
  };

  const handleNextTopic = key => {
    if (key === 1) {
      if (firstIndex < firstBlock.length - 1) {
        setFirstIndex(prev => prev + 1);
      } else {
        setFirstIndex(0);
      }
    }

    if (key === 2) {
      if (secondIndex < secondBlock.length - 1) {
        setSecondIndex(prev => prev + 1);
      } else {
        setSecondIndex(0);
      }
    }

    if (key === 3) {
      if (thirdIndex < thirdBlock.length - 1) {
        setThirdIndex(prev => prev + 1);
      } else {
        setThirdIndex(0);
      }
    }
  };

  return (
    <Wrapper>
      <Title>
        Теперь нужно выбрать диссертацию для проверки. Только темы какие-то
        странные...
      </Title>
      <Subtitle>Попробуете разобраться?</Subtitle>
      <TopicsWrapper>
        <>
          <TopicLabel>Начало</TopicLabel>
          <TopicWrapper>
            <ArrowLeft onClick={() => handlePrevTopic(1)} />
            <TopicBlock>{firstBlock[firstIndex].t}</TopicBlock>
            <ArrowRight onClick={() => handleNextTopic(1)} />
          </TopicWrapper>
          <DotsWrapper>
            {firstBlock.map((t, i) => (
              <Dot key={t.id} active={i === firstIndex} />
            ))}
          </DotsWrapper>
        </>
        <>
          <TopicLabel>Середина</TopicLabel>
          <TopicWrapper>
            <ArrowLeft onClick={() => handlePrevTopic(2)} />
            <TopicBlock>{secondBlock[secondIndex].t}</TopicBlock>
            <ArrowRight onClick={() => handleNextTopic(2)} />
          </TopicWrapper>
          <DotsWrapper>
            {secondBlock.map((t, i) => (
              <Dot key={t.id} active={i === secondIndex} />
            ))}
          </DotsWrapper>
        </>
        <>
          <TopicLabel>Хвост</TopicLabel>
          <TopicWrapper>
            <ArrowLeft onClick={() => handlePrevTopic(3)} />
            <TopicBlock>{thirdBlock[thirdIndex].t}</TopicBlock>
            <ArrowRight onClick={() => handleNextTopic(3)} />
          </TopicWrapper>
          <DotsWrapper>
            {thirdBlock.map((t, i) => (
              <Dot key={t.id} active={i === thirdIndex} />
            ))}
          </DotsWrapper>
        </>
      </TopicsWrapper>
      <Button onClick={handleNext}>Готово</Button>
      {scoreOverlay && <ScoreOverlay score={1} />}
    </Wrapper>
  );
}

export default Topic;
